import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CepApi, CepApiInfo } from 'src/app/models/CepApi.model';
import { catchError, map, of } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root'
})
export class CepService {

  constructor(private http: HttpClient,
    private snackBar: MatSnackBar,
    private apiService: ApiService) { }

  buscaCep(cep: string) {
    let cepApi: CepApi = {
      success: false,
      info: {} as CepApiInfo
    };

    const cepLimpo = cep.trim().replace(/\D+/g, '');
    return this.http.get(`https://viacep.com.br/ws/${cepLimpo}/json`).pipe(map((res: any) => {
      if (!res['erro']) {
        cepApi = {
          success: true,
          info: {
            district: res['bairro'],
            cep: res['cep'],
            complement: res['complemento'],
            ddd: res['ddd'],
            gia: res['gia'],
            ibge: res['ibge'],
            city: res['localidade'],
            address: res['logradouro'],
            siafi: res['siafi'],
            stateUF: res['uf']
          }
        };
      } else {
        this.snackBar.open("Endereço não encontrado", '', {
          duration: 2000,
          verticalPosition: 'top',
          panelClass: ['warning-snackbar']
        });
      }
      return cepApi;
    }), catchError(() => {
      this.snackBar.open("Erro de conexão ao buscar CEP. Tente novamente.", '', {
        duration: 3000,
        verticalPosition: 'top',
        panelClass: ['red-snackbar']
      });
      return of(cepApi);
    }));
  }

  public async ufExists(uf:string):Promise<boolean> {
    try{
      const r = await this.apiService.get<boolean>('/v1/nfce/uf-exists', {Uf: uf});
      if (r.success) {
        return r.data;
      }
      throw (r.message);
    } catch (err) {
      throw (err);
    }
  }
}
